<template>
    <div>
        <div class="title-lable-error">
            <span class="ml-3">No machines available</span>
        </div>
        <div
            class="d-flex flex-row align-items-center mt-3 ml-3"
            style="color: #757575; font-size: 0.85rem"
        >
            <p>
                All machines are busy now. Please
                <a @click="requestOpen" class="ml-1"
                    >Change to another package</a
                >
                to use or<a @click="request" class="ml-1"
                    >receive email notifications when available</a
                >
            </p>
        </div>
    </div>
</template>

<script>
// Event, Dialog
import EventBus from "@/event/EventBus";
export default {
    props: {
        targetImage: {
            type: Object,
            default: null,
        },
    },

    methods: {
        requestOpen() {
            EventBus.$emit("processingEventRental", {
                event: "action",
                data: {
                    type: this.$action.OPEN_POPUP_CHANGE_SERVICE_PACKAGE,
                    data: this.targetImage,
                },
            });
        },
        //#region Rental request create
        request() {
            this.$emit("processingEvent", {
                event: "rentalRequestCreate",
            });
        },
        //#endregion
    },
};
</script>